"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToasterLoading = void 0;

var _propTypes = require("prop-types");

var _stylitas = require("@creditas/stylitas");

var _components = require("./components");

const ToasterLoading = _stylitas.styled.div`
  ${_components.toasterLoading};
  ${_components.toasterIcon};
`;
exports.ToasterLoading = ToasterLoading;
ToasterLoading.displayName = 'ToasterLoading';
ToasterLoading.defaultProps = {
  variant: 'info'
};
ToasterLoading.propTypes = {
  variant: (0, _propTypes.oneOf)([_components.VARIANT_TYPES.success, _components.VARIANT_TYPES.danger, _components.VARIANT_TYPES.info, _components.VARIANT_TYPES.warning])
};